<script setup lang="ts">
import { nextTick, onMounted, ref, watch } from "vue";
import AddChatFile from "./AddChatFile.vue";
import AddSmile from "./AddSmile.vue";
import SendMessage from "./SendMessage.vue";
import SimpleBar from "simplebar";
import EmojiPicker from "./EmojiPicker.vue";
import ChatTextArea from "./ChatTextArea.vue";
import { locale } from "../../locale";
import {
  currentUploadFile,
  previewImageUrl,
  resetFile,
  setFile,
} from "../../states/chatFiles";
import PreviewFile from "./PreviewFile.vue";
import { sendMessage } from "../../states/chatState";
import {
  scrollIfBottom,
  toBottomScrollChat,
} from "../../states/scrollChatState";
import { platform } from "../../utils/platform";
import { viewState } from "../../states/viewState";

const inputscroll = ref<HTMLElement | null>(null);
onMounted(() => {
  if (inputscroll.value) {
    new SimpleBar(inputscroll.value);
  }
  if (platform !== "mobile") {
    // Для сохранения корректности анимации курсор надо выставлять по завершению анимации
    setTimeout(() => {
      const el = document.querySelector(
        ".active-room-container .right-block.animated",
      );
      if (el) {
        Promise.all(el.getAnimations().map((a) => a.finished)).then(() =>
          setCursor(),
        );
      } else setCursor();
    }, 100);
  }
});
const inputText = ref("");

function setCursor() {
  nextTick(() => {
    const textarea = document.getElementById(
      "chat-text-area",
    ) as HTMLInputElement;
    if (textarea) {
      textarea.focus();
      textarea.selectionStart = inputText.value.length;
      textarea.selectionEnd = inputText.value.length;
    }
  });
}

const emojiPush = (emoji: string) => {
  inputText.value += emoji;
  if (platform !== "mobile") setCursor();
};
const fileInput = ref<HTMLInputElement | null>(null);
function showFileSelector() {
  if (fileInput.value) {
    fileInput.value.click();
  }
}
function newFile(e: any) {
  if (e?.target?.files) {
    const files = e.target.files as FileList;
    const file = files.item(0);
    if (file) setFile(file);
    if (fileInput.value) fileInput.value.value = "";
  }
}

watch(
  () => currentUploadFile.value,
  (next) => {
    if (next && platform !== "mobile") setCursor();
  },
);

const send = () => {
  if (inputText.value.trim() !== "" || currentUploadFile.value) {
    sendMessage(
      inputText.value.trim(),
      currentUploadFile.value || undefined,
      previewImageUrl.value || undefined,
    );
    resetFile();
    nextTick(() => {
      toBottomScrollChat();
    });
    inputText.value = "";
    viewState.emojiShow = false;
  }
};
const focusInput = () => {
  if (platform === "mobile") viewState.emojiShow = false;
};
const toggleEmojiPicker = () => {
  viewState.emojiShow = !viewState.emojiShow;
  nextTick(() => {
    scrollIfBottom();
  });
};
</script>

<template>
  <div class="input-block">
    <div class="preview-message-block">
      <PreviewFile />
    </div>
    <div class="input-line">
      <div class="left-controls">
        <AddChatFile @click="showFileSelector" />
        <input
          type="file"
          ref="fileInput"
          class="file-input"
          @change="newFile"
        />
        <AddSmile :active="viewState.emojiShow" @click="toggleEmojiPicker" />
      </div>
      <ChatTextArea
        v-model="inputText"
        :placeholder="locale.chat.placeholder"
        @submit="send"
        @focus="focusInput"
      />
      <div class="send-control">
        <SendMessage
          :disabled="inputText.trim() === '' && !currentUploadFile"
          @click="send"
        />
      </div>
    </div>
    <div v-if="viewState.emojiShow" class="emoji-picker">
      <EmojiPicker @pick="emojiPush" />
    </div>
  </div>
</template>
<style scoped>
.input-block {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.input-line {
  width: 100%;
  display: flex;
  flex-direction: row;
  background-color: #2c2828;
  padding: 10px 8px 10px 4px;
  align-items: center;
  gap: 8px;
}

.left-controls {
  height: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
}

.input-scroll {
  width: 100px;
  height: 100%;
  min-height: 20px;
  max-height: 86px;
  flex-grow: 1;
}

.chat-text-area {
  cursor: pointer;
  color: #ffffff;
  white-space: pre-wrap;
}

.chat-text-area:focus {
  outline: none;
  border: none;
}

.send-control {
  display: flex;
  align-items: center;
}

.file-input {
  display: none;
}
</style>
